import React from "react";
import { useResultingListForm } from "components/_ProductConfigurator/SubComponents/ProductConfigurationResult/ProductResultMainView/ProductSuggestionResultView/providers/ResultingListFormContextProvider";
import type { Group } from "components/_ProductConfigurator/store/ProductConfiguration.types";
import { checkIsControlEnabled } from "components/_ProductConfigurator/SubComponents/ProductConfigurationResult/ProductResultMainView/ProductSuggestionResultView/ResultingListForm/Addons/AddonsHelpers";

type Props = {
  group: Group;
  groupIndex: number;
};

export const DynamicGroup: React.FC<Props> = ({ group, groupIndex }) => {
  const { values, setValue, setRadioGroupValue } = useResultingListForm();

  const inputType = group?.groupControlType === "Radio" ? "radio" : "checkbox";

  const radioIds = group?.controls?.map((c) => c.id);

  const handleChange = (
    controlId: string,
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    if (group.groupControlType === "Radio" && radioIds) {
      setRadioGroupValue(radioIds, controlId);
    } else {
      setValue(controlId, e.target.checked);
    }
  };

  return (
    <div className="mb-2">
      <div className="mb-2">
        {group.title && <strong>{group?.title}</strong>}
      </div>
      {group?.controls?.map((control) => (
        <div key={control.id} className="form-check d-flex flex-nowrap">
          <input
            type={inputType}
            name={`group-${groupIndex}-${control.id}`}
            className="form-check-input"
            checked={(values[control.id] ?? control.boolValue) as boolean}
            disabled={
              control?.enabledBy
                ? !checkIsControlEnabled(control.enabledBy, values)
                : !control?.enabled
            }
            onChange={(e) => handleChange(control.id, e)}
          />

          <label className="form-check-label">{control?.title}</label>
        </div>
      ))}
    </div>
  );
};
